import React, { useContext } from "react";
import { Form } from "react-bootstrap";
import StarekContext from "../../context/StarekContext";
import {
    SidebarView,
    SidebarContext,
    SidebarContextProvider,
    useSyncedField,
} from "../../components/Sidebar";

// Page component for device profile basic details
function DeviceProfileBasicDetails() {
    const { entity } = useContext(SidebarContext);

    const [profileName, setProfileName] = useSyncedField("name", "");
    const [profileDescription, setProfileDescription] = useSyncedField(
        "description",
        "",
    );

    return (
        <Form className="tw-flex tw-flex-col tw-gap-4">
            <div>
                <label className="tw-text-sm tw-font-medium">
                    Profile Name <span className="tw-text-red-500">*</span>
                </label>
                <input
                    type="text"
                    className="tw-w-full tw-border tw-rounded-md tw-p-2"
                    value={profileName}
                    onChange={(e) => setProfileName(e.target.value)}
                    placeholder="Enter profile name"
                />
            </div>

            <div>
                <label className="tw-text-sm tw-font-medium">Description</label>
                <textarea
                    className="tw-w-full tw-border tw-rounded-md tw-p-2"
                    rows="3"
                    value={profileDescription}
                    onChange={(e) => setProfileDescription(e.target.value)}
                    placeholder="Enter profile description"
                />
            </div>
        </Form>
    );
}

const DeviceProfileSidebar = (props) => {
    const {
        show,
        onDiscard,
        item = null,
        plantId,
        onSave = async () => {},
        onDelete = async () => {},
        onToggleActive,
    } = props;
    const starekContext = useContext(StarekContext);

    const handleSaveInternal = async (emittedData, entity) => {
        try {
            const profileName = emittedData.name?.trim();
            if (!profileName) {
                starekContext.showError("Profile name is required");
                throw new Error("Profile name is required");
            }
            if (!plantId) {
                starekContext.showError("Plant ID is required");
                throw new Error("Plant ID is required");
            }

            const payload = {
                id: entity?.id,
                name: profileName,
                description: emittedData.description || "",
                configuration: entity?.configuration || {},
            };

            await onSave(payload);

            starekContext.showSuccess(
                entity?.id
                    ? `Device Profile "${profileName}" updated successfully`
                    : `Device Profile "${profileName}" created successfully`,
            );
        } catch (error) {
            console.error("Error saving device profile:", error);
            starekContext.showError(
                error?.message ||
                    "Failed to save device profile. Please try again.",
            );
            throw error;
        }
    };

    return (
        <SidebarContextProvider
            entity={item}
            show={show}
            onSave={handleSaveInternal}
            onDelete={onDelete}
            onDiscard={onDiscard}
            onToggleActive={onToggleActive}
        >
            <SidebarView title="Device Profile">
                <SidebarView.Page name="profile_details" title="Basic Details">
                    <DeviceProfileBasicDetails />
                </SidebarView.Page>
            </SidebarView>
        </SidebarContextProvider>
    );
};

export default DeviceProfileSidebar;
